import { segment } from '@actions/analytics';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import RightChevron from 'aquilla/icons/actions/RightChevron';
import { colorList, LEADERBOARD_VIEW_ALL_CLICKED } from '../constants';
import EmptyHallOfFameList from './EmptyHallOfFameList';
import UserAwardedCard from './UserAwardedCard';

const ListWrapper = styled.div``;

const ViewMoreCta = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-top: 1px solid var(--color-divider);
  height: ${Spacings.SPACING_15B};
`;

const HallOfFameList = ({
  setOpenDialog,
  hallOfFameData,
  segmentData,
  goalSegmentData
}) => {
  if (!Object.keys(hallOfFameData).length) return null;
  const ListData = hallOfFameData.slice(0, 5);
  const isCurrentUserInTop = ListData.find(
    (winner) => winner.currentUserData === true
  );
  const currentUserData = hallOfFameData.find(
    (winner) => winner.currentUserData === true
  );
  const showEmpty = hallOfFameData.length < 2;

  const openDialog = () => {
    segment.track(LEADERBOARD_VIEW_ALL_CLICKED, {
      ...goalSegmentData,
      is_referred_a_learner: segmentData.is_referred_a_learner,
      total_referrals: segmentData.total_referrals,
      voucher_amount: segmentData.voucher_amount,
      total_extension: segmentData.total_extension,
      referral_type: segmentData.referral_type
    });
    setOpenDialog(true);
  };

  return (
    <ListWrapper>
      {showEmpty ? (
        <EmptyHallOfFameList />
      ) : (
        ListData.map((item, index) => {
          return (
            <UserAwardedCard
              key={item}
              cardData={item}
              color={colorList[index]}
              bgColor={item.currentUserData ? 'var(--color-i-voilet-24)' : ''}
            />
          );
        })
      )}
      {!isCurrentUserInTop && currentUserData && (
        <UserAwardedCard
          cardData={currentUserData}
          bgColor="var(--color-violet-1)"
        />
      )}
      <ViewMoreCta onClick={openDialog}>
        <Typography variant="h6"> View more </Typography>
        <RightChevron height={20} width={20} />
      </ViewMoreCta>
    </ListWrapper>
  );
};

export default HallOfFameList;
